import { breakpoints, css } from '../../../styles/theme';

import { rem } from 'polished';

export const StylesAC = css`
    max-height: fit-content;

    .fuel-title,
    .gearbox-title,
    .budget-title {
        text-transform: capitalize;
        color: ${({ theme }) => theme.colors.grey5};
        font-size: ${({ theme }) => theme.fontSizes.h4};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    @media (min-width: ${breakpoints.md}px) {
        padding: ${rem(16)} ${rem(24)};

        &.SOL-filter {
            padding: ${rem(16)} ${rem(24)};
        }
    }

    .grid-button {
        min-width: ${rem(120)};
        padding: 0 ${rem(15)};
        text-align: left;

        .info-check {
            svg {
                width: ${rem(18)};
                margin-left: ${rem(4)};

                g {
                    fill: ${({ theme }) => theme.colors.blue2};
                }
            }
        }
    }

    .slider-over {
        /* FYI calc has its reasons due to style override, you do not want dead 1px on md BP */
        @media (max-width: calc(${breakpoints.md}px - 0.1px)) {
            width: 90%;
        }
    }

    &.collapsed-grid {
        min-height: ${rem(72)};
    }

    .toggle-filters {
        text-transform: capitalize;
        padding: ${rem(9)} ${rem(12)};
        background: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.grey3};
        border-radius: ${rem(12)};
        color: ${({ theme }) => theme.colors.grey1};
        font-size: ${({ theme }) => theme.fontSizes.h4};

        .isOpen {
            svg {
                transform: rotateX(-180deg);
            }
        }

        svg {
            width: ${rem(14)};

            path {
                fill: ${({ theme }) => theme.colors.red};
            }
        }
    }

    .reset-filters-button {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        color: ${({ theme }) => theme.colors.grey5};
        text-transform: capitalize;

        &:hover {
            color: ${({ theme }) => theme.colors.red};
        }
    }

    .mobile-filter-close-button {
        border-top: 2px solid ${({ theme }) => theme.colors.blue2};
        background: ${({ theme }) => theme.colors.blue2};
        border-radius: unset;
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
    }

    &.expanded-grid {
        border-color: ${({ theme }) => theme.colors.blue2};
    }
`;
